import React from "react";
import { PhotoPlaceholder } from "../photo-placeholder";
import { Mail, User, Globe, Twitter, Facebook, Instagram, Linkedin, MapPin } from "lucide-react";

export function ContactSection() {
  return (
    <div className="grid gap-8 md:grid-cols-2">
      {/* Left content */}
      <div className="md:col-span-2 space-y-6">
        <h2 className="text-3xl font-semibold text-black flex items-center gap-2">
          <MapPin className="w-6 h-6 text-black" /> Venue &amp; Contact
        </h2>
        <p className="text-gray-700 flex items-center gap-1">
          <MapPin className="w-4 h-4 text-black" /> Indian Institute of Technology (IIT) Ropar, Punjab, INDIA
        </p>

        {/* Contact Card */}
        <div className="rounded-xl border border-blue-200 bg-blue-50/30 p-5 hover:shadow-md transition-all">
          <h3 className="font-semibold text-black flex items-center gap-2 mb-2">
            <Mail className="w-5 h-5" /> Contact
          </h3>
          <ul className="text-sm text-gray-700 grid gap-1.5">
            <li className="flex items-center gap-1">
              <Mail className="w-4 h-4 text-black" /> 
              Email: 
              <a
                className="text-blue-600 hover:text-blue-800 underline underline-offset-4 ml-1 transition-colors"
                href="mailto:biomanthan@iitrpr.ac.in"
              >
                biomanthan@iitrpr.ac.in
              </a>
            </li>
            <li className="flex items-center gap-1">
              <User className="w-4 h-4 text-black" /> Convener: Prof. Navin Kumar
            </li>
          </ul>
        </div>

        {/* Quick Links Card */}
        <div className="rounded-xl border border-blue-200 bg-blue-50/30 p-5 hover:shadow-md transition-all">
          <h3 className="font-semibold text-black flex items-center gap-2 mb-2">
            <Globe className="w-5 h-5" /> Quick Links
          </h3>
          <ul className="text-sm text-gray-700 grid gap-1.5">
            <li className="flex items-center gap-1">
              <Globe className="w-4 h-4 text-black" />
              <a
                className="text-black underline underline-offset-4 transition-colors"
                href="http://www.iitrpr.ac.in/biomanthan/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Conference Website
              </a>
            </li>
            <li className="flex items-center gap-1">
              <Twitter className="w-4 h-4 text-blue-400" />
              <a
                className="text-black underline underline-offset-4 transition-colors"
                href="https://twitter.com/iitrpr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Twitter
              </a>
            </li>
            <li className="flex items-center gap-1">
              <Facebook className="w-4 h-4 text-blue-700" />
              <a
                className="text-black underline underline-offset-4 transition-colors"
                href="https://www.facebook.com/iitrpr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li className="flex items-center gap-1">
              <Instagram className="w-4 h-4 text-pink-500" />
              <a
                className="text-black underline underline-offset-4 transition-colors"
                href="https://www.instagram.com/iit_ropar_official/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
            <li className="flex items-center gap-1">
              <Linkedin className="w-4 h-4 text-blue-500" />
              <a
                className="text-black underline underline-offset-4 transition-colors"
                href="https://www.linkedin.com/company/108687393/admin/dashboard/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Right: Map placeholder */}
      {/* <div className="flex items-center justify-center">
        <div className="w-full rounded-2xl border border-blue-200 bg-gradient-to-br from-blue-50 to-blue-100 p-4 shadow-sm">
          <PhotoPlaceholder label="Maps &amp; directions (add later)" />
        </div>
      </div> */}
    </div>
  );
}
